import script from "./Hamburger.vue?vue&type=script&setup=true&lang=js"
export * from "./Hamburger.vue?vue&type=script&setup=true&lang=js"

import "./Hamburger.vue?vue&type=style&index=0&id=89980c2c&lang=scss&scoped=true"

import exportComponent from "D:\\Code\\wisecard\\smart-tms-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-89980c2c"]])

export default __exports__